<template>
  <RowTemplate
    :header="header"
    :total="total"
    :list="list"
  />
</template>

<script>
import RowTemplate from '@/Pages/Shifts/Components/Table/SummaryTable/RowTemplate';

export default {
  name: 'FulltimeConversionRow',
  components: {
    RowTemplate,
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  computed: {
    total() {
      const cnt = this.list.length;

      if (cnt === 0) {
        return '0';
      }

      const total = this.list.reduce((acc, cur) => acc + cur, 0);

      return total.toFixed(2);
    },
  },
};
</script>
